module.exports = __webpack_public_path__ + "img/72.4.NH3-N.5b07237c.png";